var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    SqlConditionsBrickModel: function (opts) {
        var form = opts.form
            , entityDropdown = form.find('[name="EntityId"]');

        entityDropdown.on('change', loadAttributeEditors);
        Operator.Layout.setupCollections(form, loadAttributeEditors);
        loadAttributeEditors();

        function loadAttributeEditors() {
            var entityId = entityDropdown.val();
            var attributeDropdown = $('.attribute-dropdown[data-entity-id="' + entityId + '"]').clone().html();

            _.forEach(form.find('.statement-model [name$="AttributeId"]'), function (e) {
                var $e = $(e);
                $e.html(attributeDropdown);
                $e.val($e.data('current'));
            });
        }
    }
});